var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99996 1.16663C3.7783 1.16663 1.16663 3.7783 1.16663 6.99996C1.16663 10.2216 3.7783 12.8333 6.99996 12.8333C10.2216 12.8333 12.8333 10.2216 12.8333 6.99996C12.8295 3.77985 10.2201 1.17038 6.99996 1.16663ZM10.3673 5.15274L7.03982 9.66822C6.96046 9.77351 6.84213 9.8425 6.71141 9.85968C6.5807 9.87687 6.44855 9.84081 6.34468 9.75961L3.96857 7.85989C3.75889 7.6921 3.72494 7.38609 3.89274 7.17642C4.06053 6.96674 4.36653 6.93279 4.57621 7.10058L6.5576 8.68579L9.58461 4.57767C9.68387 4.42872 9.85696 4.34637 10.0351 4.36331C10.2133 4.38025 10.3678 4.49375 10.4372 4.65874C10.5066 4.82372 10.4797 5.01351 10.3673 5.15274Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.27eaee94.svg";
export { ForwardRef as ReactComponent };